import React, { useEffect } from 'react'
import { actionAtom } from 'atoms/atoms'
import { useAtomValue } from 'jotai'
import { useTranslation } from 'react-i18next'
import { Box, Callout } from '@node-space/ui-components'
import { useFeatureFlags } from 'hooks/useFeatureFlags'
import { ApiKeyRequestForm } from 'types/apiKeys'
import {
  AmplitudeEvent,
  AmplitudeEventAction,
  AmplitudeEventCategory,
} from 'utils/amplitude/amplitudeEvents'
import track from 'utils/tracker'
import ApiKeyCreateFormComponent from '../../../Form/ApiKeyCreateForm'

type PaymentCreateModalProps = {
  from2FA?: boolean
  onSuccessCreateApiKey: (value: ApiKeyRequestForm) => void
}

export const ApiKeyCreateForm = ({
  onSuccessCreateApiKey,
  from2FA = false,
}: PaymentCreateModalProps) => {
  const { t } = useTranslation()
  const apiKeyAction = useAtomValue(actionAtom)
  const { enablePayrollRole } = useFeatureFlags()

  useEffect(() => {
    track.Amp.track(AmplitudeEvent.API_KEY_INITIATE, {
      category: AmplitudeEventCategory.MERCHANT_PORTAL,
      action: AmplitudeEventAction.VIEW,
    })
  }, [])

  return (
    <Box className="max-w-[608px] w-full mx-auto">
      {from2FA && <Callout variant="success">{t('2FAEnabled')}</Callout>}
      <ApiKeyCreateFormComponent
        onSubmit={(formData: ApiKeyRequestForm) => onSuccessCreateApiKey(formData)}
        enablePayrollRole={enablePayrollRole}
        dismissAction={apiKeyAction?.onClose}
      />
    </Box>
  )
}
